import Vue from 'vue'
import App from './App.vue'
import VueScrollProgressBar from '@guillaumebriday/vue-scroll-progress-bar'
import vueSmoothScroll from 'vue2-smooth-scroll'

Vue.use(vueSmoothScroll)

Vue.component("vue-scroll-progress-bar", VueScrollProgressBar)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js